/* =============================================================================
 * Configuracao de runtime.
 *
 * Vem de window.ConfigFutigol, definido por /config.js - um script bloqueante
 * que NAO passa pelo bundle. E' isso que permite apontar o app publicado para
 * outra API editando um arquivo no servidor, sem rebuild.
 * ========================================================================== */

/** Sem barra no fim: quem monta o endereco sempre concatena a partir dela. */
export function normalizarUrl(url) {
    if (!url) return '';
    return String(url).trim().replace(/\/+$/, '');
}

const bruto = globalThis.window?.ConfigFutigol ?? {};

export const config = {
    titulo: bruto.Titulo || 'Futigol',
    identificadorConexao: 'PRISMA_FUTIGOL',
    urlServico: normalizarUrl(bruto.UrlServico) || 'http://localhost:5000',
    urlServicoFile: normalizarUrl(bruto.UrlServicoFile),
    modoDesenvolvedor: bruto.ModoDesenvolvedor === true,
    desabilitarServiceWorker: bruto.DesabilitarServiceWorker === true,
    //Forca o modo master no ambiente inteiro, independente do usuario. Mesma
    //chave do iPrisma (window.Config.UsuarioMaster) - serve para homologar sem
    //ter de mexer no cadastro. Ver sessao/capacidades.js#ehMaster.
    usuarioMaster: bruto.UsuarioMaster === true,
};

/**
 * Base do endpoint de arquivos, na ordem em que o iPrisma a resolve
 * (LibGeral.GetUrlFile, iPrisma\scripts\LibGeral.js):
 *
 *   1. `UrlServicoFile` deste arquivo - o servico dedicado apontado a mao no
 *      aparelho/servidor, que existe justamente para sobrepor o resto;
 *   2. `ConfigGeral.UrlPrismaFile`, que veio do SERVIDOR no shell - e' ele quem
 *      sabe por onde os arquivos daquele ambiente sao servidos, e a resposta
 *      muda conforme o servidor que atendeu a requisicao (ver
 *      LibPrisma.ObtemUrlPrismaFile);
 *   3. `<UrlServico>/file`, a queda de sempre.
 *
 * O (2) chega por parametro, e nao lido daqui: config.js e' o que o APARELHO
 * sabe antes de falar com a API, e a sessao e' de outra camada. Quem junta os
 * dois e' lib/arquivos.js, o unico lugar que monta URL de arquivo.
 */
export function urlBaseArquivo(urlDoServidor = '') {
    return config.urlServicoFile || normalizarUrl(urlDoServidor) || `${config.urlServico}/file`;
}
